export default {
  dynamics: '{{change}} face à semana anterior',
};
